export default function (arr1, arr2) {
  // Check if both arrays have the same length
  if (arr1.length !== arr2.length) {
    return false;
  }

  // Create shallow copies of the input arrays and sort them
  const sortedArr1 = [...arr1].sort();
  const sortedArr2 = [...arr2].sort();

  // Compare the sorted arrays element by element
  return sortedArr1.every((e, i) => e === sortedArr2[i]);
}
